import React from 'react'
import { EditPaymentMethodFlowMain } from './components/EditPaymentMethodFlowMain'
import { EditPaymentMethodFlowProvider } from './context/EditPaymentMethodFlowProvider'

export const EditPaymentMethodFlow = () => {
  return (
    <EditPaymentMethodFlowProvider>
      <EditPaymentMethodFlowMain />
    </EditPaymentMethodFlowProvider>
  )
}
